import React from 'react';

export function AssignmentPromptModal({ pendingAssignments, onSubmitAssignment, onRemindLater, onClose }) {
  const firstAssignment = pendingAssignments[0]; // Show the first pending assignment
  const totalCount = pendingAssignments.length;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#E8F3FF] rounded-3xl shadow-2xl border-0 max-w-md w-full p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center">
              <span className="text-xl">📋</span>
            </div>
            <div>
              <h3 className="text-xl font-bold text-navy">Assignment Required</h3>
              {totalCount > 1 && (
                <p className="text-sm text-[#4D4D4D]">{totalCount} pending assignments</p>
              )}
            </div>
          </div>
          <button 
            onClick={onClose}
            className="text-[#4D4D4D] hover:text-navy transition-colors"
          >
            ✕
          </button>
        </div>
        
        <div className="mb-6">
          <div className="p-4 bg-white rounded-2xl border-2 border-yellow-200 mb-4">
            <h4 className="font-bold text-navy mb-1">
              {firstAssignment.lesson.title}
            </h4>
            <p className="text-sm text-[#4D4D4D] mb-2">
              {firstAssignment.assignment.title}
            </p>
            <p className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full font-semibold inline-block">
              Mandatory
            </p>
          </div>
          
          <p className="text-[#4D4D4D] text-sm leading-relaxed">
            This lesson is marked complete, but an assignment is still pending. Please submit the assignment to unlock the next lesson.
          </p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={() => onSubmitAssignment(firstAssignment.assignment.id)}
            className="w-full bg-primary-blue hover:bg-[#1874CD] text-white font-semibold py-3 px-4 rounded-2xl transition-smooth flex items-center justify-center space-x-2"
          >
            <span>📝</span>
            <span>Submit Assignment</span>
          </button>
          
          <button
            onClick={onRemindLater}
            className="w-full bg-white hover:bg-gray-50 text-navy border-2 border-[#E7E7E7] font-semibold py-3 px-4 rounded-2xl transition-smooth"
          >
            Remind me later
          </button>
        </div>
      </div>
    </div>
  );
}
